import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {OrderStatus} from 'src/app/models/OrderStatus';
import {OrderType} from 'src/app/models/OrderType';
import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';
import {Observable, forkJoin} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DigitalBoardService {
	private ORDER_URL = '/v2/order';

	constructor(private http: HttpClient) {}

	getFilteredOrders(data: {
		venue: string;
		status: OrderStatus[];
		orderTypes: OrderType[];
		from: string;
		to: string;
		promoCode: boolean;
	}): Observable<Order[]> {
		let params = new HttpParams({
			fromObject: {}
		});

		if (data) {
			if (data?.venue) {
				params = params.append('venue[]', data.venue);
			}
			if (data.status) {
				data.status.forEach((value: string) => {
					params = params.append(`status[]`, value.toString());
				});
			}
			if (data.orderTypes) {
				data.orderTypes.forEach((type: string) => {
					params = params.append(`type[]`, type.toString());
				});
			}
			if (data.from) {
				params = params.append('from', data.from);
			}
			if (data.to) {
				params = params.append('to', data.to);
			}
			if (data.promoCode) {
				params = params.append('promoCode', data.promoCode);
			}
		}
		return this.http.get<Order[]>(
			`${environment.apiUrl}${this.ORDER_URL}/filtered`,
			{params}
		);
	}

	getOrderPools(data: {
		venue: string;
		status: OrderStatus[];
		orderTypes: OrderType[];
		from: string;
		to: string;
		promoCode: boolean;
	}): Observable<OrderPool[]> {
		let params = new HttpParams({
			fromObject: {}
		});

		if (data) {
			if (data?.venue) {
				params = params.append('venue', data.venue);
			}
			if (data.status) {
				data.status.forEach((value: string) => {
					params = params.append(`orderStatus[]`, value.toString());
				});
			}
			if (data.from) {
				params = params.append('from', data.from);
			}
			if (data.to) {
				params = params.append('to', data.to);
			}
		}
		return this.http.get<OrderPool[]>(
			`${environment.apiUrl}${this.ORDER_URL}/pool`,
			{params}
		);
	}

	getBoardData(venueId: string): Observable<[Order[], OrderPool[]]> {
		const today = new Date();
		const from = new Date(today.setHours(0, 0, 0, 0)).toISOString();
		const to = new Date(today.setHours(23, 59, 59, 999)).toISOString();

		const orderTypes = [
			OrderType.TERMINAL,
			OrderType.STANDARD,
			OrderType.VIRTUAL,
			OrderType.PREORDER
		];

		const requestData = {
			venue: venueId,
			status: [OrderStatus.IN_PREPARATION, OrderStatus.READY],
			orderTypes,
			from,
			to,
			promoCode: true
		};

		return forkJoin([
			this.getFilteredOrders(requestData),
			this.getOrderPools(requestData)
		]);
	}
}
